import { c as _c } from "react/compiler-runtime";
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepConfigurationTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-configuration-tab-content';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
interface StepConfigurationTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface;
  isMobile?: boolean;
  exitMobileTab?: () => void;
}
function StepConfigurationTab(t0) {
  const $ = _c(5);
  const {
    funnelId,
    funnelStep
  } = t0;
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep) {
    t1 = getFunnelStepConfigurationTabContent(funnelStep, funnelId);
    $[0] = funnelId;
    $[1] = funnelStep;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default StepConfigurationTab;